<template>
    <div class="app-view-default-template">
      <!-- Content template with slot -->

      <app-content-default-template >
        <slot/>
      </app-content-default-template>
    </div>
</template>

<script>
  import AppContentDefaultTemplate from '@/components/layout/templates/content/AppContentTemplateDefault';

  export default {
    name: 'AppViewTemplateDefault',

    components: {
      AppContentDefaultTemplate,
    }
  }
</script>

<style scoped lang="scss">
  .app-view-default-template {
    width: 100%;
    margin-top: $headerMobileHeight;

    @media (min-width: $lgBreakpoint) {
      margin-top: $headerDesktopHeight;
    }
  }
</style>
